<!-- 插件套餐 -->
<template>
    <div>
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.keywords"
                placeholder="请输入插件套餐名称"
            ></Input>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.status"
                clearable
                filterable
            >
                <Option
                    v-for="item in statusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24"
                icon="ios-search"
                type="warning"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="gomodal"
                >增加插件套餐</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="title">
                    <div>{{ row.apps ? row.apps.title : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="status">
                    <div class="flex-c">
                        <i-switch
                            v-model="row.status"
                            size="large"
                            true-color="#FF761D "
                            :true-value="1"
                            :false-value="0"
                            @on-change="changeStatus(row)"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button
                            type="primary"
                            ghost
                            label="small"
                            @click="gomodal(row)"
                            >编辑</Button
                        >
                        <Button
                            type="error"
                            ghost
                            label="small"
                            @click="goDel(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>

        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="700"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="form_item"
                    label-position="right"
                    :label-width="130"
                >
                    <FormItem label="序号：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.sort"
                            placeholder="请输入"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="tooltip-icon"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D"
                            />
                            <div slot="content">
                                <p>正序，序号越小，越在前面</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="插件：">
                        <Select
                            class="w300"
                            v-model="form_item.apps_id"
                            placeholder="请选择插件"
                            clearable
                            filterable
                            @on-change="changeAppsId"
                        >
                            <Option
                                v-for="item in appsList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.title }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="插件套餐名称：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="form_item.name"
                            placeholder="请输入插件套餐名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="商品图片：">
                        <Upload
                            ref="upload"
                            :show-upload-list="false"
                            :format="['jpg', 'jpeg', 'png', 'gif']"
                            :max-size="5120"
                            :on-exceeded-size="exceededSize"
                            :on-progress="handleProgress"
                            :on-format-error="handleFormatError"
                            :on-success="iconSuccess"
                            :headers="upload_headers"
                            :action="upload_action"
                        >
                            <div class="upload-container">
                                <img
                                    v-if="form_item.icon"
                                    :src="show_icon"
                                    class="wh80"
                                />
                                <Icon
                                    v-else
                                    type="ios-add"
                                    size="40"
                                    color="#AEAEB3"
                                />
                            </div>
                        </Upload>
                    </FormItem>
                    <FormItem label="原价：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.ori_price"
                            placeholder="请输入"
                            ><span slot="append">元</span></Input
                        >
                    </FormItem>
                    <FormItem label="售价：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.price"
                            placeholder="请输入"
                            ><span slot="append">元</span></Input
                        >
                    </FormItem>
                    <FormItem label="插件套餐简介：">
                        <Input
                            class="w500"
                            type="textarea"
                            v-model="form_item.desc"
                            placeholder="请输入"
                        ></Input>
                    </FormItem>
                    <FormItem label="插件套餐详情：">
                        <editor
                            class="w500"
                            :edtor-con="form_item.details"
                            :index="1"
                            @getContent="getEnContent"
                            @getContentchange="getEnContentchange"
                        />
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    version_apps,
    version_apps_save,
    version_apps_change,
    version_apps_sort,
    version_apps_del,
    account_app_select,
    version_apps_version_info,
    version_apps_info,
} from "@/api/index";
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
import editor from "@/components/editor/editor.vue";
export default {
    components: { editor },
    data() {
        return {
            upload_action: config.apiUrl + "/plat/other/upload",
            upload_headers: {
                "hlzw-plat-suyuan-token": getCookies("platToken"),
            },
            storePrams: {
                page: 1,
                limit: 30,
                keywords: "",
                status: -1,
            },
            total: 0,
            statusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "下架" },
                { id: 1, name: "上架" },
            ],
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "序号", key: "sort", align: "center" },
                { title: "插件套餐名称", key: "name", align: "center" },
                { title: "插件类型", slot: "title", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                { title: "金额", key: "price", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            form_item: {
                name: "",
                sort: "",
                apps_id: "",
                price: "",
                ori_price: "",
                id: "",
                icon: "",
                desc: "",
                details: "",
            },
            appsList: [],
            show_icon: "",
            id: "",
            info_data: {},
            progress_value: 0,
        };
    },
    mounted() {
        this.getList();
        this.getVersionApps();
    },
    methods: {
        getList() {
            version_apps(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        getSort() {
            version_apps_sort().then((res) => {
                this.form_item.sort = res.data.sort;
            });
        },
        getInfo() {
            version_apps_info({ id: this.form_item.id })
                .then((res) => {
                    this.form_item.name = res.data.name;
                    this.form_item.sort = res.data.sort;
                    this.form_item.apps_id = res.data.apps_id;
                    this.form_item.price = res.data.price;
                    this.form_item.ori_price = res.data.ori_price;
                    this.form_item.icon = res.data.icon;
                    this.form_item.desc = res.data.desc;
                    this.form_item.details = res.data.details;
                    this.show_icon = res.data.show_icon;
                    this.info_data = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        gomodal(row) {
            if (row.id) {
                this.modalTitle = "编辑插件套餐";
                this.form_item.id = row.id;
                this.getInfo();
            } else {
                this.modalTitle = "增加插件套餐";
                this.form_item.name = "";
                this.form_item.apps_id = "";
                this.form_item.price = "";
                this.form_item.ori_price = "";
                this.form_item.id = "";
                this.form_item.icon = "";
                this.form_item.desc = "";
                this.form_item.details = "";
                this.show_icon = "";
                this.getSort();
            }
            this.$nextTick(() => {
                this.modals = true;
            });
        },
        // 确定
        submitModal() {
            version_apps_save(this.form_item)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        changeStatus(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变状态吗？",
                onOk: () => {
                    version_apps_change({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    version_apps_del({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        getVersionApps() {
            account_app_select()
                .then((res) => {
                    this.appsList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        //富文本
        getEnContent(detailData) {
            this.form_item.details = detailData.editorData;
        },
        getEnContentchange(detailData) {
            this.form_item.details = detailData.editorData;
        },
        // 文件上传时
        handleProgress(e) {
            this.progress_value++;
            if (this.progress_value == 1) {
                if (e.percent == 100) {
                    this.$Message.loading({
                        content: "上传中...",
                        duration: 0,
                    });
                    return;
                }
                this.$Message.loading({
                    content: "上传中...",
                    duration: 0,
                });
            }
        },
        exceededSize() {
            this.$Message.warning("文件大小限制在5MB以内");
            this.progress_value = 0;
        },
        // 文件上传类型错误
        handleFormatError() {
            this.$Message.destroy();
            this.$Message.warning("暂不支持上传此格式");
            this.progress_value = 0;
        },
        // 平台logo图片上传成功
        iconSuccess(e) {
            this.form_item.icon = e.data.url;
            this.show_icon = e.data.path;
            this.$Message.destroy();
            this.$Message.success(e.msg);
            this.progress_value = 0;
        },
        changeAppsId(e) {
            console.log("e", e);
            if (e) {
                if (this.info_data.apps_id == e) {
                    this.form_item.name = this.info_data.name;
                    this.form_item.sort = this.info_data.sort;
                    this.form_item.apps_id = this.info_data.apps_id;
                    this.form_item.price = this.info_data.price;
                    this.form_item.ori_price = this.info_data.ori_price;
                    this.form_item.id = this.info_data.id;
                    this.form_item.icon = this.info_data.icon;
                    this.form_item.desc = this.info_data.desc;
                    this.form_item.details = this.info_data.details;
                    this.show_icon = this.info_data.show_icon;
                } else {
                    this.id = e;
                    this.getVersionAppsInfo();
                }
            } else {
                this.form_item.name = "";
                this.form_item.price = "";
                this.form_item.ori_price = "";
                this.form_item.icon = "";
                this.form_item.desc = "";
                this.form_item.details = "";
                this.show_icon = "";
            }
        },
        getVersionAppsInfo() {
            version_apps_version_info({ id: this.id })
                .then((res) => {
                    this.form_item.name = res.data.title;
                    this.form_item.price = res.data.price ? res.data.price : "";
                    this.form_item.ori_price = res.data.ori_price
                        ? res.data.ori_price
                        : "";
                    this.form_item.icon = res.data.icon;
                    this.form_item.desc = res.data.desc;
                    this.form_item.details = res.data.details;
                    this.show_icon = res.data.show_icon;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.text-align-right {
    text-align: right;
}
.upload-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 5px;
    border: 1px solid #9fa5bb;
    cursor: pointer;
}
.wh80 {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.tooltip-icon {
    margin-left: 10px;
    cursor: pointer;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-checkbox-group.ivu-checkbox-default {
    display: inline-block;
}
</style>